import { EstablishmentMovementsTotalizerData } from '@/features/establishments/types/establishmentMovementsTotalizer.type';
import ResumeItem from './ResumeItem';
import { establishmentResumeItems } from '@/features/establishments/constants/establishmentMovementsTotalizer.constant';

interface ResumeListProps {
  data: EstablishmentMovementsTotalizerData ;
}

const ResumeList = ({ data }: ResumeListProps) => {
  return (
    <div className="flex gap-6">
      {establishmentResumeItems(data).filter((item) => item.value).map((itemConfig, index) => <ResumeItem key={index} {...itemConfig}/>)}
    </div>
  )
}

export default ResumeList